module.exports = __webpack_public_path__ + "static/media/e&ohead.f57cadfb.jpg";